import { Injectable } from '@angular/core';
import { ApiService, UtilService, PagedSearch, PagedResult } from '../../../shared/index';
import { PagedResult as GenericPagedResult } from '../../../shared/model/generic-paged-result.model';
import { IEventItemService } from './ievent-item.service';
import { EventItemCreditType } from './event-item-credit-type.model';
import { EventItemAffCode } from './event-item-aff-code.model';

import { EventItemSummary } from './event-item-summary.model';
import { EventItemEdit } from './event-item-edit.model';

@Injectable()
export class EventItemService implements IEventItemService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  private getEventItemsApiGetUrl = (eventId: number): string => {
    let url: string = '/Event/' + eventId.toString() + '/EventItems';
    return url;
  };

  public getEventItems = (eventId: number): Promise<Array<EventItemSummary>> => {
    if (!eventId) {
      return Promise.resolve([]);
    }

    let url: string = this.getEventItemsApiGetUrl(eventId); //"/Event/" + eventId.toString() + "/EventItems";

    return this._apiService.get(url).then((data: PagedResult) => {
      return Promise.resolve(data.Result);
    });
  };

  public deleteEventItemsCache = (eventId: number): void => {
    let url: string = this.getEventItemsApiGetUrl(eventId);

    this._apiService.deleteCache(url);
  };

  public getEventItemToEdit = (eventItemId: number): Promise<EventItemEdit> => {
    let url: string = '/EventItem/' + eventItemId.toString();
    return this._apiService.get(url).then((data: EventItemEdit) => {
      let eventItemToEdit = data;

      if (!eventItemToEdit.AffCodes) eventItemToEdit.AffCodes = [];

      if (!eventItemToEdit.AffCodeRestrictions) eventItemToEdit.AffCodeRestrictions = [];

      if (!eventItemToEdit.CreditTypes) eventItemToEdit.CreditTypes = [];

      for (let affCodeRes of data.AffCodeRestrictions) {
        eventItemToEdit.AffCodes.push(affCodeRes.AffCode);
      }

      return Promise.resolve(eventItemToEdit);
    });
  };

  public getNewEventItem = (eventId: number): Promise<EventItemEdit> => {
    let newEventItem = new EventItemEdit();
    newEventItem.EventId = eventId;
    newEventItem.AttendeesForItem = 1;
    newEventItem.IsPublic = true;
    return Promise.resolve(newEventItem);
  };

  public upsertEventItem = (eventItemEdit: EventItemEdit): Promise<number> => {
    let url: string = '';
    url = 'EventItem/Upsert';

    eventItemEdit.AffCodeRestrictions = new Array<EventItemAffCode>();
    if (eventItemEdit.RestrictForAffiliations) {
      for (let affCode of eventItemEdit.AffCodes) {
        let itemAffCode = new EventItemAffCode();
        itemAffCode.AffCode = affCode;
        itemAffCode.EventItemId = eventItemEdit.EventItemId;

        eventItemEdit.AffCodeRestrictions.push(itemAffCode);
      }
    }

    return this._apiService.post(url, eventItemEdit).then((data: number): Promise<number> => {
      return Promise.resolve(data);
    });
  };

  public copyEventItem = (eventItemEdit: EventItemEdit): Promise<number> => {
    let url: string = '';
    url = 'EventItem/Copy';

    return this._apiService.post(url, eventItemEdit).then((data: number): Promise<number> => {
      return Promise.resolve(data);
    });
  };

  public removeEventItem = (eventItemId: number): Promise<any> => {
    let url: string = '/EventItem/' + eventItemId;
    return this._apiService.delete(url);
  };

  public getEventItemCeus = (eventItemId: number): Promise<GenericPagedResult<Array<EventItemCreditType>>> => {
    let params: PagedSearch = new PagedSearch();
    params.PageSize = 0;
    params.PageNumber = 1;
    let url: string = '/EventItem/' + eventItemId + '/CreditTypes';
    return this._apiService.getPaged(url, params);
  };

  public reorderEventItems(eventId: number, orderedEventItemIds: Array<number>): Promise<any> {
    let url: string = '/Event//' + eventId + '/OrderItems';
    return this._apiService.post(url, orderedEventItemIds);
  }

  public getEventItemAttendeeCount = (eventId: number, eventItemId: number): Promise<number> => {
    let url: string = 'EventItem/' + eventId + '/' + eventItemId + '/AttendeeCount';
    return this._apiService.get(url);
  };
}
